import { useQuery } from '@tanstack/react-query'
import { gameEnabledService } from '../../../../services/games/games-enableds'
import { setGraphClientAuthToken } from '../../../../services/graph-client'

export const GAME_ENABLED_FIRST_QUERY_KEY = ['getGameEnabledFirst']

export const useGetGameEnabledFirst = (options?: { token?: string | null; enabled?: boolean }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: GAME_ENABLED_FIRST_QUERY_KEY,
    staleTime: Infinity,
    enabled: options?.enabled ?? true,
    queryFn: () => {
      setGraphClientAuthToken(options?.token)
      return gameEnabledService.getFirst()
    },
  })

  return {
    gameEnabled: data?.data,
    isLoading: isLoading,
    refetch,
  }
}
